import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'

import header from './components/header'
import collection from './components/collection'
import collectionKlevu from './components/collection-klevu'
import cartDrawer from './components/cart-drawer'
import productImageSlider from './components/product-image-slider'
import product from './components/product'
import featuredProductsSlider from './components/featured-products-slider'
import scrollSnapSlider from './components/scroll-snap-slider'
import productInfoModals from './components/product-info-modals'
import search from './components/search'
import searchResults from './components/search-results'
import loadMore from './components/load-more'
import customerAccount from './components/customer-account'
import video from './components/video'
import collectionGridCta from './components/collection-grid-cta'
import smartRecommendations from './components/smart-recommendations'
import productCtaSlider from './components/product-cta-slider'
import countrySwitcher from './components/country-switcher'
import cartFeaturedProducts from './components/cart-featured-products'

window.Alpine = Alpine

Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(persist)

Alpine.data('header', header)
Alpine.data('collection', collection)
Alpine.data('collectionKlevu', collectionKlevu)
Alpine.data('cartDrawer', cartDrawer)
Alpine.data('productImageSlider', productImageSlider)
Alpine.data('product', product)
Alpine.data('featuredProductsSlider', featuredProductsSlider)
Alpine.data('scrollSnapSlider', scrollSnapSlider)
Alpine.data('productInfoModals', productInfoModals)
Alpine.data('search', search)
Alpine.data('searchResults', searchResults)
Alpine.data('loadMore', loadMore)
Alpine.data('customerAccount', customerAccount)
Alpine.data('video', video)
Alpine.data('collectionGridCta', collectionGridCta)
Alpine.data('smartRecommendations', smartRecommendations)
Alpine.data('productCtaSlider', productCtaSlider)
Alpine.data('countrySwitcher', countrySwitcher)
Alpine.data('cartFeaturedProducts', cartFeaturedProducts)

import { money, imageTransform } from './directives'
Alpine.directive('money', money)
Alpine.directive('image-transform', imageTransform)

Alpine.start()
